export default __webpack_public_path__ + "images/4a29405bdc8cb0dc42dc476f91b426cb-datamart-logo.svg";